import React, { useState } from "react";
import InputBlockv1 from "../UI/components/InputBlockv1";
import { Link, useNavigate } from "react-router";
import InputPhoneV1 from "../UI/components/InputPhoneV1";
import apiRequest from "../service/api/api.request";
import appState from "../service/state/app.state";
import { PassInput } from "../UI/components/input/PassInput";

const Registration = () => {
  const [firstName, setFirstName] = useState("");
  const [errFirstName, setErrFirstName] = useState("standart_border");

  const [lastName, setLastName] = useState("");
  const [errLastName, setErrLastName] = useState("standart_border");

  const [fatherName, setFatherName] = useState("");

  const [organization, setOrganization] = useState("");
  const [errorOganization, setErrorOrganization] = useState("standart_border");

  const [emailName, setEmailName] = useState("");
  const [errEmailName, setErrEmailName] = useState("standart_border");

  const [phoneName, setPhoneName] = useState("");
  const [errPhoneName, setErrPhoneName] = useState("standart_border");

  const [passName, setPassName] = useState("");
  const [errPassName, setErrPassName] = useState("standart_border");

  const [repassName, setRePassName] = useState("");
  const [errRePassName, setErrRePassName] = useState("standart_border");

  const navigation = useNavigate();

  const registrationNew = async (e) => {
    try {
      e.preventDefault();
      const regEmail = emailName.match(/^.*@.*\.[\w-]{2,10}$/);
      const handlerError = (name, func) => {
        if (name === "") {
          func("error_inpt");
        } else {
          func("standart_border");
        }
      };

      handlerError(firstName, setErrFirstName);

      handlerError(lastName, setErrLastName);
      handlerError(emailName, setErrEmailName);
      handlerError(phoneName, setErrPhoneName);
      handlerError(organization, setErrorOrganization);
      if (passName !== repassName || passName.length < 8) {
        setErrPassName("error_inpt");
        // handlerError(passName, setErrPassName);
        // handlerError(repassName, setErrRePassName);
      } else {
        setErrPassName("standart_border");
      }
      if (
        firstName === "" ||
        lastName === "" ||
        phoneName === "" ||
        passName === "" ||
        firstName.length < 2 ||
        lastName.length < 3 ||
        !regEmail ||
        phoneName.length < 9 ||
        passName.length < 8 ||
        passName !== repassName
      ) {
        console.log(123);
        return;
      } else {
        const res = await apiRequest.newUser({
          first_name: firstName,
          last_name: lastName,
          father_name: fatherName,
          organization: organization,
          email: emailName,
          phone: phoneName,
          password: passName,
        });
        if (res) {
          console.log(res.success);
          const t = res.data.access_token.replace(/..$/, "");
          const k = String(res.data.access_token.match(/..$/));
          const r = appState.r();
          localStorage.setItem("at", appState.e(t));
          localStorage.setItem("k", appState.e(k + r));
          appState.setParameters("isAuth", true);
          return navigation("/home");
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="login_container">
      <form className="registration_form_container">
        <p className="login_form_title">Регистрация</p>
        <InputBlockv1
          title="Имя"
          placeholder="Введите имя"
          value={firstName}
          setValue={setFirstName}
          cls={errFirstName}
        />
        <InputBlockv1
          title="Фамилия"
          placeholder="Введите фамилию"
          value={lastName}
          setValue={setLastName}
          cls={errLastName}
        />
        <InputBlockv1
          title="Отчество"
          placeholder="Введите отчество"
          value={fatherName}
          setValue={setFatherName}
          cls={errorOganization}
          // error={errFatherName}
        />
        <InputBlockv1
          title="Организация"
          placeholder="Введите организацию"
          value={organization}
          setValue={setOrganization}
          cls={errorOganization}
          // error={errorOganization}
        />
        <InputBlockv1
          title="Email"
          placeholder="Введите email"
          value={emailName}
          setValue={setEmailName}
          cls={errEmailName}
          // error={errEmailName}
        />
        <InputPhoneV1
          title="Телефон"
          placeholder="Введите телефон"
          // type="number"
          value={phoneName}
          cls={errPhoneName}
          setValue={setPhoneName}
          // error={errPhoneName}
        />
        {/* <InputBlockv1
          title="Пароль"
          placeholder="Введите пароль"
          value={passName}
          setValue={setPassName}
          cls={errPassName}
          // error={errPassName}
          type="password"
        />
        <InputBlockv1
          title="Повторите пароль"
          placeholder="Введите пароль"
          value={repassName}
          setValue={setRePassName}
          cls={errRePassName}
          // error={errRePassName}
          type="password"
        /> */}{" "}
        <PassInput
          title="Пароль"
          value={passName}
          setFunc={setPassName}
          // error={errPassName}
        />
        <PassInput
          title="Повторите пароль"
          value={repassName}
          setFunc={setRePassName}
          // error={errRePassName}
        />
        <div className="login_btn_container">
          <Link className="reg_btn" to={"/login"}>
            Логин
          </Link>
          <button onClick={registrationNew} className="login_btn" type="submit">
            Зарегистрироваться
          </button>
        </div>
      </form>
    </div>
  );
};

export default Registration;
